import React from "react"
import TopImages from "./TopImages"

type GuideFrameProps = {
  inquiry_data1: any,
  inquiry_data2: any,
  menu_name: string,
}

const GuideFrame = (props: GuideFrameProps) => {
    const {
      inquiry_data1,
      inquiry_data2,
      menu_name,
    } = props
  
    return (
      <>
        <div className="guide-frame_container">
          <div className="guide-frame_head">この{menu_name}が気になりましたか？</div>
          <div className="guide-frame_top-content">
            <div className="guide-frame_top-bar start"></div>
            <div className="guide-frame_top-text">お気軽にご相談ください</div>
            <div className="guide-frame_top-bar end"></div>
          </div>
          <div className="guide-frame_inquiry-container">
            <a className="guide-frame_inquiry-box" href={inquiry_data1.url} onClick={(e) => {e.stopPropagation()}}>
              <div className="guide-frame_inquiry-box-content">
                <div className="guide-frame_inquiry-box-icon">
                  <img
                    src={inquiry_data1.icon}
                    loading="lazy"
                    onError={(e) => TopImages.handleOnError(e, inquiry_data1.icon)}
                  />
                </div>
                <div className="guide-frame_inquiry-box-text"> {inquiry_data1.text} </div>
                <div className="guide-frame_inquiry-box-triangle"></div>
              </div>
            </a>
            <a className="guide-frame_inquiry-box" href={inquiry_data2.url} onClick={(e) => {e.stopPropagation()}}>
              <div className="guide-frame_inquiry-box-content">
                <div className="guide-frame_inquiry-box-icon">
                  <img
                    src={inquiry_data2.icon}
                    loading="lazy"
                    onError={(e) => TopImages.handleOnError(e, inquiry_data2.icon)}
                  />
                </div>
                <div className="guide-frame_inquiry-box-text"> {inquiry_data2.text} </div>
                <div className="guide-frame_inquiry-box-triangle"></div>
              </div>
            </a>
          </div>
        </div>
      </>
    )
}

export default GuideFrame
